import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Server, Lock, User, Loader2 } from "lucide-react";
import { useAuth } from "@/components/auth/AuthProvider";
import { apiError } from "@/lib/api";
import { OtpStep } from "@/components/auth/OtpStep";

export default function Login() {
  const { user, login, verify } = useAuth();
  const [otp, setOtp] = useState(null);
  const nav = useNavigate();
  const loc = useLocation();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={loc.state?.from || "/"} replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const ch = await login(u.trim(), p);
      if (ch) setOtp(ch); else nav(loc.state?.from || "/", { replace: true });
    }
    catch (ex) { setErr(apiError(ex, "Não foi possível entrar.")); }
    setBusy(false);
  };
  const inp = "w-full rounded-xl border border-[#1F293D] bg-[#0B0F17] py-3 pl-10 pr-3 text-sm text-white outline-none transition-colors focus:border-sky-500";
  return (
    <div data-testid="login-page" className="flex min-h-screen items-center justify-center bg-[#0B0F17] px-4">
      <div className="w-full max-w-sm rounded-2xl border border-[#1F293D] bg-[#0F141F] p-7 shadow-2xl fade-up">
        <div className="mb-7 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 shadow-lg shadow-sky-500/20"><Server className="h-5 w-5 text-white" /></div>
          <div>
            <div className="text-lg font-extrabold tracking-tight text-white">SYSLOG</div>
            <div className="text-xs text-slate-400">CRM de Cobrança · acesso restrito</div>
          </div>
        </div>
        {otp ? <OtpStep otp={otp} onBack={() => { setOtp(null); setP(""); }}
          onVerify={async (code) => { await verify(otp, code); nav(loc.state?.from || "/", { replace: true }); }} /> : (
        <form onSubmit={submit}>
        <label className="text-xs font-medium text-slate-400">Usuário</label>
        <div className="relative mb-4 mt-1">
          <User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input data-testid="login-username" autoFocus autoComplete="username" value={u} onChange={(e) => setU(e.target.value)} className={inp} required />
        </div>
        <label className="text-xs font-medium text-slate-400">Senha</label>
        <div className="relative mt-1">
          <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input data-testid="login-password" type="password" autoComplete="current-password" value={p} onChange={(e) => setP(e.target.value)} className={inp} required />
        </div>
        {err && <div data-testid="login-error" className="mt-4 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-300">{err}</div>}
        <button data-testid="login-submit" disabled={busy} className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-sky-500 py-3 text-sm font-bold text-slate-950 transition-transform hover:-translate-y-0.5 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Entrar
        </button>
        </form>)}
      </div>
    </div>
  );
}
